export default __webpack_public_path__ + "static/media/GES_VIERGE.6e85bb99.png";